// @ts-nocheck
/* eslint-disable class-methods-use-this */
import { css } from 'lit';
import { html, unsafeStatic } from 'lit/static-html.js';
import WarpElement from '@warp-ds/elements-core';
import '@warp-ds/icons/elements/facebook-24';
import '@warp-ds/icons/elements/twitter-24';
import '@warp-ds/icons/elements/instagram-24';
import '@warp-ds/icons/elements/youtube-24';
import { brandFounded, getBrand, getBrandAndCompanyTagline, getBrandAndCompanyType, hostToBrand } from './utils.js';
import './schibsted-banner.js';
import './tcf-privacy-manager.js';

class FinnFooter extends WarpElement {
    static styles = [
        ...WarpElement.styles,
        css`
            .pageholder {
                margin: 0;
                padding: 0;
            }

            @media (min-width: 1300px) {
                .pageholder {
                    padding: 0 15px 0;
                    margin: 0 auto;
                }

                .brand-content {
                    place-self: center !important;
                }
            }

            .content {
                display: -ms-grid;
                display: grid;
                -ms-grid-columns: 33.332% 1fr 1fr 1fr 1fr;
                grid-template-columns: 33.332% 1fr 1fr 1fr 1fr;
                -ms-grid-rows: auto;
                grid-template-rows: auto;
                grid-template-areas:
                    'branding business about privacy support'
                    'divider divider divider divider divider'
                    'social copyrights copyrights copyrights copyrights';
            }

            @media (max-width: 989px) {
                .content {
                    display: block;
                    margin: 0;
                }

                .branding svg {
                    margin: 0 auto 8px;
                }

                .details {
                    max-width: 692px;
                }

                .cookie-settings-btn {
                    display: flex;
                    margin-right: auto;
                    margin-left: auto;
                }
            }

            .branding {
                grid-area: branding;
            }
            *,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.text-body{font-size:var(--w-font-size-m);line-height:var(--w-line-height-m)}@media (min-width:990px){.lg\\:text-detail{font-size:var(--w-font-size-xs);line-height:var(--w-line-height-xs)}}.bg-no-repeat{background-repeat:no-repeat}.border-t,.border-t-1{border-top-width:1px}.border-solid{border-style:solid}.last\\:hidden:last-child{display:none}.hover\\:underline:hover,.focus\\:underline:focus,.active\\:underline:active{text-decoration-line:underline}.flex-row{flex-direction:row}.flex-wrap{flex-wrap:wrap}.gap-x-40{column-gap:4rem}.gap-y-4{row-gap:.4rem}.place-self-center{place-self:center}.static{position:static}.h-32{height:3.2rem}.w-6{width:.6rem}.max-w-screen-lg{max-width:990px}.space-y-8>:not([hidden])~:not([hidden]){--w-space-y-reverse:0;margin-top:calc(.8rem*calc(1 - var(--w-space-y-reverse)));margin-bottom:calc(.8rem*var(--w-space-y-reverse))}.mx-16{margin-left:1.6rem;margin-right:1.6rem}.mx-32{margin-left:3.2rem;margin-right:3.2rem}.my-16{margin-top:1.6rem;margin-bottom:1.6rem}.my-32{margin-top:3.2rem;margin-bottom:3.2rem}.mb-16{margin-bottom:1.6rem}.mt-32{margin-top:3.2rem}.py-16{padding-top:1.6rem;padding-bottom:1.6rem}.py-24{padding-top:2.4rem;padding-bottom:2.4rem}.pl-16{padding-left:1.6rem}.pt-64{padding-top:6.4rem}.text-12{font-size:var(--w-font-size-xs);line-height:var(--w-line-height-xs)}.text-14{font-size:var(--w-font-size-s);line-height:var(--w-line-height-s)}.text-16{font-size:var(--w-font-size-m);line-height:var(--w-line-height-m)}.text-22{font-size:var(--w-font-size-l);line-height:var(--w-line-height-l)}@media (min-width:990px){.lg\\:text-left{text-align:left}.lg\\:block{display:block}.lg\\:inline{display:inline}.lg\\:justify-start{justify-content:flex-start}.lg\\:place-self-start{place-self:start}.lg\\:h-4{height:.4rem}.lg\\:w-4{width:.4rem}.lg\\:my-32{margin-top:3.2rem;margin-bottom:3.2rem}.lg\\:-ml-4{margin-left:-.4rem}.lg\\:ml-16{margin-left:1.6rem}.lg\\:mr-8{margin-right:.8rem}.lg\\:mt-0{margin-top:0}.lg\\:pl-16{padding-left:1.6rem}};
        `,
    ];

    get logo() {
        let { host } = this;

        if (typeof window !== 'undefined') {
            host = this.getAttribute('host');
        }

        if (host.includes('tori')) {
            return html` <span class="block">
                <svg width="105" height="52" viewBox="0 0 105 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <title>Tori.fi</title>
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M104.646 6.59596C104.611 9.94545 101.875 12.6368 98.5254 12.6169C95.1758 12.5971 92.4723 9.87348 92.4772 6.52381C92.4821 3.17414 95.1936 0.458476 98.5432 0.448421C100.173 0.435911 101.74 1.08105 102.888 2.238C104.037 3.39494 104.67 4.96599 104.646 6.59596ZM47.0728 16.9032C36.8933 16.9032 29.3855 24.2863 29.3855 34.1754C29.3855 44.0646 36.8933 51.4475 47.0728 51.4475C57.2861 51.4475 64.8277 44.0645 64.8277 34.1754C64.8277 24.2863 57.2861 16.9033 47.0728 16.9033V16.9032ZM47.0729 25.1335C52.0443 25.1335 55.7982 28.8588 55.7982 34.176C55.7982 39.4931 52.0443 43.2184 47.0729 43.2184C42.1015 43.2184 38.3815 39.493 38.3815 34.176C38.3815 28.8589 42.1016 25.1335 47.0729 25.1335V25.1335ZM85.7885 16.9033C81.764 16.9033 78.6189 18.2918 76.5559 21.3737V17.7838H67.9997V50.6009H76.8265V32.7191C76.8265 27.8423 80.6319 25.641 85.1733 25.641C88.9691 25.641 90.3878 26.386 90.3878 26.386V17.7838C88.9294 17.1843 87.3652 16.8848 85.7885 16.9033V16.9033ZM103.007 17.7842H94.1799V50.6012H103.007V17.7842ZM27.0213 17.7846H15.1509V8.94539H6.32412V17.7847H0V25.6418H6.32412V38.3419C6.32412 46.8425 10.4838 51.4484 18.6004 51.4484C22.5759 51.4698 26.4526 50.2106 29.6567 47.857L25.9542 41.2384C24.1618 42.3222 22.1514 43.2187 20.0546 43.2187C17.3153 43.2187 15.1509 41.7285 15.1509 37.6307V25.6418H27.0213L27.0213 17.7846Z"
                        fill="#F94F55"
                    />
                </svg>
            </span>`;
        }

        if (host.includes('dba')) {
            return html` <span class="block">
                <svg width="76" height="49" viewBox="0 0 76 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_5429_2606)">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.2558 9.14486H21.7099C22.0149 9.1414 22.2655 9.3842 22.2706 9.68822V38.5797C22.2673 38.7241 22.2062 38.8612 22.1009 38.9604C21.9955 39.0596 21.8547 39.1126 21.7099 39.1076H17.9099C17.5857 39.0989 17.2951 38.9058 17.1624 38.6108L16.6951 37.3843C14.8951 38.9493 12.5893 39.8146 10.2009 39.8217C4.5787 39.8217 0 35.0401 0 29.1562C0 23.2723 4.5787 18.4907 10.2009 18.4907C12.5916 18.5005 14.8981 19.3717 16.6951 20.9436V9.6727C16.6984 9.52829 16.7595 9.39119 16.8648 9.29202C16.9702 9.19284 17.111 9.13984 17.2558 9.14486ZM5.591 29.1717C5.591 32.1214 8.08281 34.5122 11.1509 34.5122C14.2189 34.5122 16.7107 32.1214 16.7107 29.1717C16.7107 26.222 14.2189 23.8312 11.1509 23.8312C8.08281 23.8312 5.591 26.222 5.591 29.1717Z"
                            fill="#00098A"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M33.6363 20.9377C35.431 19.3626 37.7391 18.4913 40.1306 18.486C45.7528 18.486 50.3315 23.2807 50.3315 29.1616C50.3315 35.0425 45.7528 39.8217 40.1306 39.8217C37.7399 39.8119 35.4333 38.9411 33.6363 37.37L33.1691 38.5959C33.0315 38.8866 32.7439 39.0777 32.4216 39.0924H28.6216C28.4768 39.0974 28.336 39.0444 28.2306 38.9453C28.1253 38.8462 28.0642 38.7092 28.0609 38.5648V9.67243C28.0642 9.5281 28.1253 9.39107 28.2306 9.29194C28.336 9.19281 28.4768 9.13984 28.6216 9.14486H33.0757C33.2205 9.13984 33.3613 9.19281 33.4666 9.29194C33.572 9.39107 33.6331 9.5281 33.6363 9.67243V20.9377ZM33.6364 29.1461C33.6364 32.0943 36.1282 34.4839 39.1962 34.4839C42.2643 34.4839 44.7561 32.0943 44.7561 29.1461C44.7561 26.1979 42.2643 23.8083 39.1962 23.8083C36.1282 23.8083 33.6364 26.1979 33.6364 29.1461Z"
                            fill="#00098A"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M71.1808 19.2541H75.3078C75.4526 19.2491 75.5934 19.3021 75.6988 19.4013C75.8041 19.5006 75.8652 19.6377 75.8685 19.7822V38.6533C75.8652 38.7977 75.8041 38.9349 75.6988 39.0341C75.5934 39.1333 75.4526 39.1864 75.3078 39.1814H71.5078C71.1836 39.1727 70.893 38.9795 70.7603 38.6843L70.293 37.4573C68.493 39.023 66.1872 39.8888 63.7988 39.8958C58.1766 39.8958 53.5979 35.112 53.5979 29.2255C53.5979 23.339 58.1766 18.5552 63.7988 18.5552C66.1882 18.5566 68.4959 19.4231 70.293 20.9937L70.5266 19.7667C70.6043 19.4686 70.872 19.2589 71.1808 19.2541ZM64.7488 34.5529C67.8012 34.5529 70.293 32.1765 70.3086 29.241V29.1789C70.293 26.2434 67.8168 23.867 64.7488 23.867C61.6807 23.867 59.1889 26.2589 59.1889 29.2099C59.1889 32.161 61.6963 34.5529 64.7488 34.5529Z"
                            fill="#00098A"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_5429_2606">
                            <rect width="75.8684" height="31" fill="white" transform="translate(0 9)" />
                        </clipPath>
                    </defs>
                </svg>
            </span>`;
        }

        return html`<span aria-hidden="true">
            <svg width="93" height="32" fill="none">
                <title>FINN.no</title>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.752 2.088h-8.23a.93.93 0 0 0-.93.929v25.966a.93.93 0 0 0 .93.93h26.951V20.77c0-10.302-8.398-18.683-18.721-18.683Z"
                    fill="#0063FB"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M89.478 2.088h-55.98a.93.93 0 0 0-.932.929v26.895h56.912a.93.93 0 0 0 .93-.928V3.017a.93.93 0 0 0-.93-.93Z"
                    fill="#06BEFB"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.592 28.983V3.017a.93.93 0 0 1 .93-.93h8.23c10.323 0 18.722 8.382 18.722 18.684v9.141H3.523a.93.93 0 0 1-.93-.928Zm87.816 0a.93.93 0 0 1-.93.93H32.565V3.016a.93.93 0 0 1 .93-.93h55.981a.93.93 0 0 1 .93.93v25.966ZM89.478 0H33.496a3.023 3.023 0 0 0-3.023 3.017V11.7C27.094 4.78 19.972 0 11.752 0h-8.23A3.023 3.023 0 0 0 .5 3.017v25.966A3.023 3.023 0 0 0 3.523 32h85.954a3.023 3.023 0 0 0 3.023-3.017V3.017A3.023 3.023 0 0 0 89.477 0Z"
                    fill="#fff"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M42.007 10.575h7.538c.328 0 .593.265.593.592v1.856a.592.592 0 0 1-.593.592h-4.834v2.449h3.85c.327 0 .592.265.592.592v1.58a.592.592 0 0 1-.593.592h-3.849v2.005a.592.592 0 0 1-.593.592h-2.11a.592.592 0 0 1-.594-.592v-9.666c0-.327.266-.592.593-.592Zm11.415 0h2.111c.328 0 .593.265.593.592v9.666a.592.592 0 0 1-.593.592h-2.111a.592.592 0 0 1-.593-.592v-9.666c0-.327.265-.592.593-.592Zm27.544 0h-2.111a.592.592 0 0 0-.593.592v4.74l-3.301-4.979a.791.791 0 0 0-.66-.353H72.68a.592.592 0 0 0-.593.592v9.666c0 .327.266.592.593.592h2.112a.592.592 0 0 0 .593-.592v-4.685l3.229 4.92a.791.791 0 0 0 .661.357h1.692a.592.592 0 0 0 .594-.592v-9.666a.592.592 0 0 0-.594-.592Zm-14.828 0h2.112c.328 0 .593.265.593.592v9.666a.592.592 0 0 1-.593.592h-1.692a.79.79 0 0 1-.662-.357l-3.229-4.92v4.685a.592.592 0 0 1-.593.592h-2.111a.592.592 0 0 1-.593-.592v-9.666c0-.327.265-.592.593-.592h1.622c.265 0 .513.133.66.354l3.3 4.978v-4.74c0-.327.266-.592.593-.592Z"
                    fill="#fff"
                />
            </svg>
            <span class="text s-text font-bold">Mulighetenes marked</span>
        </span>`;
    }

    footerLink(footerLink) {
        if (footerLink.url.includes('internal:cookie-settings')) {
            return html` <button
                id="footer-tcf-privacy-manger"
                style="display:none"
                class="cookie-settings-btn text s-text lg:text-left bg-transparent ease-in-out lg:inline active:underline focus:underline hover:underline"
            >
                ${footerLink.label}
            </button>`;
        }
        return html` <a class="text s-text block" href="${footerLink.url}">${footerLink.label}</a> `;
    }

    footerSection(footerSections) {
        return footerSections?.map(
            (sec) => html`
                <div class="lg:pl-16 text-center s-text text-14 space-y-8 lg:text-left">
                    <h2 class="h4 mt-32 lg:mt-0">${sec.section}</h2>
                    ${sec.items?.map((link) => this.footerLink(link))}
                </div>
            `,
        );
    }

    socialMediaIcon(icon) {
        return `w-icon-${icon}`;
    }

    socialMediaSection(socialMedia) {
        return socialMedia?.map(
            (sm) => html`
            <a
                class='block p-4 fill-current s-icon lg:-ml-4 -mt-4 h-32 w-32'
                href='${sm.url}'
                title='${sm.label}'
                target='_blank'
                rel='noopener nofollow'
            >
                <${unsafeStatic(this.socialMediaIcon(sm.icon))}></${unsafeStatic(this.socialMediaIcon(sm.icon))}>
            </a>
        `,
        );
    }

    brandSection(brandFooterData) {
        return html`
            <span class="hidden lg:block lg:mr-8">${brandFooterData.title}:</span>
            <div class="flex flex-row items-center m-0 justify-center flex-wrap gap-8">
                ${brandFooterData.links.map(
                    (link) =>
                        html`<a href="${link.url}" target="_blank">${link.label}</a
                            ><span class="rounded-full h-6 w-6 lg:h-4 lg:w-4 s-bg-primary last:hidden"></span>`,
                )}
            </div>
        `;
    }

    render() {
        let { sites, displaySocialMedia, host, footerData, socialMedia, privacyLink, brandFooterData } = this;

        // On the client, use attributes.
        if (typeof window !== 'undefined') {
            host = this.getAttribute('host');
            sites = this.getAttribute('sites');
            displaySocialMedia = JSON.parse(this.getAttribute('displaySocialMedia'));
            footerData = JSON.parse(this.getAttribute('footerData'));
            socialMedia = JSON.parse(this.getAttribute('socialMedia'));
            privacyLink = this.getAttribute('privacyLink');
            brandFooterData = JSON.parse(this.getAttribute('brandFooterData'));
        }

        // Debug.
        /* console.log(
            host,
            sites,
            displaySocialMedia,
            footerData,
            socialMedia,
            privacyLink,
            brandFooterData,
        ); */

        const brand = hostToBrand(host);

        return html`
            <footer class="border border-t-1 s-border pt-64 s-bg s-text">
                <div class="pageholder max-w-screen-lg" data-some-footer-tracking>
                    <nav
                        class="content"
                        aria-label="${this.i18n.t({
                            id: 'footer.nav.aria-label',
                            message: 'Footer',
                            comment: 'aria label used on the nav element in the footer',
                        })}"
                    >
                        <h1 class="branding text-center pl-16 mb-32 lg:text-left">
                            <a class="text-22 s-text-subtle" href="${sites}" data-automation-id="frontpage-link">
                                <span
                                    role="img"
                                    aria-label="${this.i18n.t({
                                        id: 'footer.nav.header.logo.aria-label',
                                        message: 'Logo for {brand}',
                                        values: {
                                            brand: getBrandAndCompanyTagline(brand),
                                        },
                                        comment:
                                            "aria label for the footer logo used in the header, the brand argument can be e.g 'Logo for FINN.no, mulighetenes marked'",
                                    })}"
                                >
                                    ${this.logo}
                                </span>
                            </a>
                        </h1>

                        ${footerData ? this.footerSection(footerData) : ''}

                        <hr
                            class="p-0 mt-32 lg:ml-16 border-solid border-t s-border"
                            style="grid-area: divider;"
                            aria-hidden="true"
                        />

                        <div
                            class="flex flex-wrap lg:justify-start justify-center gap-x-40 gap-y-4 mx-16 my-32"
                            style="grid-area: social;"
                        >
                            ${displaySocialMedia
                                ? html`<h2 class="sr-only">
                                          ${this.i18n.t({
                                              id: 'footer.social-media.title',
                                              message: 'Social media',
                                              comment: 'title for the social media section',
                                          })}
                                      </h2>
                                      ${this.socialMediaSection(socialMedia)}`
                                : html``}
                        </div>

                        <section
                            aria-label="${this.i18n.t({
                                id: 'footer.section.copyright.aria-label',
                                message: 'Copyright',
                                comment: 'aria label for the copyright section in the footer',
                            })}"
                            class="mx-16 my-16 lg:my-32 text-12 text-center s-text-subtle lg:text-left"
                            style="grid-area: copyrights;"
                        >
                            <p class="details mx-auto mb-16">
                                ${this.i18n.t({
                                    id: 'footer.copyright.text',
                                    message:
                                        'The content is protected by the Copyright Act. Regular, systematic, or continuous gathering, storage, indexing, distribution, and any other form of compilation of data is not permitted without explicit, written permission from {brand}.',
                                    values: { brand: getBrand(brand) },
                                    comment: "privacy statement, brand is e.g 'FINN.no'",
                                })}
                            </p>
                            <p class="mb-0">
                                © ${brandFounded(brand)}–${new Date().getFullYear()} ${getBrandAndCompanyType(brand)}
                            </p>
                        </section>
                    </nav>
                </div>
                ${brandFooterData
                    ? html`<section class="py-16 border-t s-border flex flex-col">
                          <div class="place-self-center lg:place-self-start brand-content">
                              <div class="flex flex-wrap items-center justify-center mx-16 text-body lg:text-detail">
                                  ${this.brandSection(brandFooterData)}
                              </div>
                          </div>
                      </section>`
                    : html``}
                <section
                    aria-label="${this.i18n.t({
                        id: 'footer.section.privacy.aria-label',
                        message: 'Privacy in Schibsted',
                        comment: 'aria label for the privacy section in the footer',
                    })}"
                    id="schibsted-banner"
                    class="py-24 text-16 schibsted-banner border-t s-border"
                    style="background-color: #f8f6f5;"
                >
                    <div class="pageholder max-w-screen-lg">
                        <div class="flex items-center">
                            <div
                                role="img"
                                aria-label="${this.i18n.t({
                                    id: 'footer.section.privacy.logo.aria-label',
                                    message: 'Schibsted logo',
                                    comment: 'aria label for the schibsted logo in the privacy section of the footer',
                                })}"
                                class="hidden md:block mx-16 block bg-no-repeat"
                            ></div>
                            <div class="hidden md:block flex-grow text-14">
                                ${this.i18n.t({
                                    id: 'footer.section.privacy.text',
                                    message:
                                        '{brand} is a part of Schibsted Marketplaces. Schibsted News Media AB and Schibsted ASA are responsible for your data on this site.',
                                    values: { brand: getBrand(brand) },
                                    comment:
                                        'privacy statement text, brand is e.g "FINN.no", shown on tablet size devices and larger',
                                })}

                                <a href="${privacyLink}" target="_blank" rel="noopener" class="text s-text"
                                    >${this.i18n.t({
                                        id: 'footer.section.privacy.read-more.link',
                                        message: 'Read more',
                                        comment: 'link to read more about privacy statement',
                                    })}</a
                                >
                            </div>
                            <div class="flex-grow text-12 mx-32 md:hidden">
                                ${this.i18n.t({
                                    id: 'footer.section.privacy.mobile-text',
                                    message: 'Schibsted is responsible for your data on this page',
                                    comment: 'privacy statement text, shown on mobile size devices',
                                })}
                                <a href="${privacyLink}" target="_blank" rel="noopener" class="text s-text"
                                    >${this.i18n.t({
                                        id: 'footer.section.privacy.read-more.link',
                                        message: 'Read more',
                                        comment: 'link to read more about privacy statement',
                                    })}</a
                                >
                            </div>
                        </div>
                    </div>
                </section>
            </footer>
        `;
    }
}

if (!customElements.get('finn-footer')) {
    customElements.define('finn-footer', FinnFooter);
}
